import React from 'react';

function Icon({ color = '#153E35', ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            fill="none"
            viewBox="0 0 16 17"
            className={props.className}
        >
            <path
                fill={color}
                d="M12.172 7.5L6.808 2.136 8.222.722 16 8.5l-7.778 7.778-1.414-1.414L12.172 9.5H0v-2h12.172z"
            ></path>
        </svg>
    );
}

export default Icon;
